import { HeaderInfo } from '@/UI/HeaderInfo';
import { motion } from 'framer-motion';
import { useLocation, useParams } from 'react-router-dom';
import { HistoryItem } from './components/HistoryItem';
import { useQuery } from '@tanstack/react-query';
import { getTestsList, ResponseGetTestsList } from './api/getTestsList';
import { getTestsData, ResponseGetTestsData } from './api/getTestsData';
import { useTranslation } from 'react-i18next';
import i18n from '@/localisation/i18n';

export const TestHistory = () => {
  const { i18n: i18nInstance } = useTranslation();
  const location = useLocation();
  const state =
    (location.state as {
      data?: any[];
      levels?: any;
      title?: string;
    } | null) || {};
  const { client, type } = useParams();

  const { data: testData } = useQuery<ResponseGetTestsData>({
    queryKey: ['tests-data', i18nInstance.language],
    staleTime: 60 * 60 * 1000,
    queryFn: () => getTestsData({ lang: i18nInstance.language }),
    enabled: !state.levels || !state.title,
  });

  const { data: testsList, isLoading } = useQuery<ResponseGetTestsList>({
    queryKey: ['tests', i18nInstance.language, client],
    staleTime: 5 * 60 * 1000,
    queryFn: () => getTestsList({ user: client! }),
    enabled: !state.data,
  });

  const currentTest = testData?.find(
    t => t.id.toLowerCase() === type?.toLowerCase()
  );
  const levels = state.levels || currentTest?.levels || {};
  const title = state.title || currentTest?.title || '';
  const data =
    state.data ||
    testsList?.filter(j => j.type.toLowerCase() === type?.toLowerCase()) ||
    [];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <HeaderInfo title={title}>
        {isLoading && !data.length ? (
          <div className="flex h-64 items-center justify-center">
            <span className="loading loading-spinner loading-lg text-primary"></span>
          </div>
        ) : data.length === 0 ? (
          <div className="mt-8 text-center text-gray-500">
            {i18n.t('no.records')}
          </div>
        ) : (
          <div className="mt-8 grid gap-4 lg:grid-cols-3">
            {data.map((i: any) => (
              <HistoryItem
                key={i.id}
                id={i.id}
                score={i.score}
                creationDate={i.creationDate}
                levels={levels}
                title={title}
              />
            ))}
          </div>
        )}
      </HeaderInfo>
    </motion.div>
  );
};
